export default "__VITE_ASSET__BeEHX5Yt__";